import { createAction } from "@reduxjs/toolkit";

interface Selection {
  index: number;
  value: string;
}

interface SubmitSelectionsPayload {
  componentID: string;
  selections: Selection[];
}

// Define Action Types for DiagramQuestion
export const ACTION_TYPES = {
  UPDATE_SELECTIONS: "UPDATE_SELECTIONS",
  SUBMIT_SELECTIONS: "SUBMIT_SELECTIONS",
} as const;

// Define action creators using createAction
export const updateSelections = createAction(
  ACTION_TYPES.UPDATE_SELECTIONS,
  (data: Selection[]) => ({ payload: data })
);

export const submitSelections = createAction(
  ACTION_TYPES.SUBMIT_SELECTIONS,
  (payload: SubmitSelectionsPayload) => ({ payload })
);
